/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Empty/view.blocks to change it.
import * as fromHelpers from './helpers.js'
import React from 'react'
import Timeout from 'DesignSystem/Timeout/react'



/** @type {import('Simple/types.js').View} */
export default function Empty({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Phone/NewPhone/Content/SearchForPhone/Content/Empty"
  
}) {
let onTimeout = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<Timeout
  viewPath={`${viewPath}/Timeout`}
 onTimeout={onTimeout}
/>
{children}
</React.Fragment>)
}